export const data1 = [
  {
    image: 'https://www.pngitem.com/pimgs/m/179-1793755_bitcoin-vector-icon-bitcoin-ico-png-transparent-png.png',
    code: 'BTC',
    fullName: 'Bitcoin',
    price: '$9,890.00',
    persen: '+3.00%',
  },
  {
    image: 'https://s2.coinmarketcap.com/static/img/coins/200x200/11346.png',
    code: 'RACA',
    fullName: 'RadioCaca',
    price: '$19,890.00',
    persen: '+13.00%',
  },
  {
    image: 'https://static.okx.com/cdn/assets/imgs/221/5F33E3F751873296.png',
    code: 'ETH',
    fullName: 'Etherium',
    price: '$19,890.00',
    persen: '+13.00%',
  },
  {
    image: 'https://s2.coinmarketcap.com/static/img/coins/200x200/2.png',
    code: 'LTC',
    fullName: 'Litecoin',
    price: '$19,890.00',
    persen: '+13.00%',
  },
  {
    image: 'https://pbs.twimg.com/profile_images/1536732976817418242/Y2SUEmDt_400x400.jpg',
    code: 'ADA',
    fullName: 'Cardano',
    price: '$19,890.00',
    persen: '+13.00%',
  },
  {
    image: 'https://i.pinimg.com/originals/5a/b9/ed/5ab9ed02c58fd9401660d5da197cd1de.png',
    code: 'DOT',
    fullName: 'Polkadot',
    price: '$19,890.00',
    persen: '+13.00%',
  },
];

export const data2 = [
  {
    image: 'https://s2.coinmarketcap.com/static/img/coins/200x200/2.png',
    code: 'LTC',
    fullName: 'Litecoin',
    price: '$19,890.00',
    persen: '+13.00%',
  },
  {
    image: 'https://pbs.twimg.com/profile_images/1536732976817418242/Y2SUEmDt_400x400.jpg',
    code: 'ADA',
    fullName: 'Cardano',
    price: '$19,890.00',
    persen: '+13.00%',
  },
  {
    image: 'https://i.pinimg.com/originals/5a/b9/ed/5ab9ed02c58fd9401660d5da197cd1de.png',
    code: 'DOT',
    fullName: 'Polkadot',
    price: '$19,890.00',
    persen: '+13.00%',
  },
  {
    image: 'https://www.pngitem.com/pimgs/m/179-1793755_bitcoin-vector-icon-bitcoin-ico-png-transparent-png.png',
    code: 'BTC',
    fullName: 'Bitcoin',
    price: '$9,890.00',
    persen: '+3.00%',
  },
  {
    image: 'https://s2.coinmarketcap.com/static/img/coins/200x200/11346.png',
    code: 'RACA',
    fullName: 'RadioCaca',
    price: '$19,890.00',
    persen: '+13.00%',
  },
  {
    image: 'https://static.okx.com/cdn/assets/imgs/221/5F33E3F751873296.png',
    code: 'ETH',
    fullName: 'Etherium',
    price: '$19,890.00',
    persen: '+13.00%',
  },
];
